module.exports = {"422801001":"舞阳坝街道","422801002":"六角亭街道","422801003":"小渡船街道","422801100":"龙凤镇","422801101":"崔家坝镇","422801102":"板桥镇","422801103":"白杨坪镇","422801104":"三岔镇","422801201":"新塘乡","422801202":"红土乡","422801203":"沙地乡","422801204":"太阳河乡","422801205":"屯堡乡","422801206":"白果乡","422801207":"芭蕉侗族乡","422801208":"盛家坝乡","422801400":"恩施大峡谷风景管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/422801.json
// module id = 1792
// module chunks = 0